export default function extEStCalc(einkommen) {
  const klassen = [
    { min: 0, max: 12816 / 12, satz: 0 },
    { min: 12816.01 / 12, max: 20818 / 12, satz: 0.2 },
    { min: 20818.01 / 12, max: 34513 / 12, satz: 0.3 },
    { min: 34513.01 / 12, max: 66612 / 12, satz: 0.4 },
    { min: 66612.01 / 12, max: 99266 / 12, satz: 0.48 },
    { min: 99266.01 / 12, max: 1000000 / 12, satz: 0.5 },
    { min: 1000000.01 / 12, max: Infinity, satz: 0.55 },
  ];
  console.log("einkommenSteuerBerechnen");
  let berechneteSteuer = 0;

  for (let i = 0; i < klassen.length; i++) {
    const klasse = klassen[i];

    if (einkommen >= klasse.min) {
      const zuVersteuernderBetrag = Math.min(
        einkommen - klasse.min,
        klasse.max - klasse.min
      );
      berechneteSteuer += zuVersteuernderBetrag * klasse.satz;
    }
  }

  return berechneteSteuer;
}
